import { formatDate } from '@angular/common';
import { ILSessionDate } from '@models/instructor-led';
import { IlSession } from '@queries/generated';
import moment from 'moment-mini';

export function sessionsForToday(sessions: IlSession[]): IlSession[] {
  return sessions.filter((session) => moment().isSame(session.startsAt, 'day'));
}

export function hasSessionToday(sessions: IlSession[]): boolean {
  return sessionsForToday(sessions).length > 0;
}

export function sessionsPrevious(sessions: IlSession[]): IlSession[] {
  return sessions.filter((session) => moment().isAfter(session.startsAt, 'day'));
}

export function hasSessionPrevious(sessions: IlSession[]): boolean {
  return sessionsPrevious(sessions).length > 0;
}

export function sessionsUpcoming(sessions: IlSession[]): IlSession[] {
  return sessions.filter((session) => moment().isBefore(session.startsAt, 'day'));
}

export function hasSessionUpcoming(sessions: IlSession[]): boolean {
  return sessionsUpcoming(sessions).length > 0;
}

export function nearestSessionToday(sessions: IlSession[]): IlSession | null {
  const nearest = sessions.sort((a) => moment(a.startsAt).diff(Date.now()));
  return nearest[0];
}

function stripOffset(date: string): string {
  if (typeof date === 'object') {
    date = (date as Date).toString();
  }
  return date.substring(0, date.length - 6);
}

export function toLocalDate(date: string) {
  if (date) {
    return new Date(stripOffset(date));
  }
  return null;
}

export function toLocalDates(session: ILSessionDate): any {
  return {
    startsAt: toLocalDate(session.startsAt),
    endsAt: toLocalDate(session.endsAt),
    timeZone: session.timeZone
  };
}

export function toServerDateTime(date: Date | string) {
  if (date) {
    return formatDate(date, 'yyyy-MM-ddTHH:mm', 'en');
  }
  return null;
}

export function toServerDateTimes(session: ILSessionDate): ILSessionDate {
  return {
    startsAt: toServerDateTime(session.startsAt),
    endsAt: toServerDateTime(session.endsAt),
    timeZone: session.timeZone
  };
}

export function syncDay(src: Date, dst: Date): Date {
  dst.setFullYear(src.getFullYear());
  dst.setMonth(src.getMonth());
  dst.setDate(src.getDate());
  return dst;
}

export function startsAndEndsOnDay<T extends { startsAt?: string | Date; endsAt?: string | Date }>(
  src: Date,
  session: T
): T {
  if (session.startsAt) {
    session.startsAt = syncDay(src, new Date(session.startsAt));
  }
  if (session.endsAt) {
    session.endsAt = syncDay(src, new Date(session.endsAt));
  }
  return session;
}
